import React from 'react';

const About = () => {
  return (
    <section id="about">
      <h3>About</h3>
      <p>
      I am currently a third year Computer Science and Economics Major at Northeastern University who is interested in Full-Stack Development, Fintech, and Machine Learning. I have experience working with many languages and frameworks, and I am always looking to gain more experience. Please feel free to contact me at connorpkarr@gmail.com if you are interested in my website!
      </p>
      <p>
      I have professional experience working on large-scale backend systems in a production engineering environment. During my six-month co-op as a Fintech Backend Engineer at Priceline, I worked on financial transaction services and backend microservices, building and testing REST APIs, validating data flows with SQL, and improving core validation logic to support reliable, high-volume booking systems.      </p>
      <p>
      In the past, I have worked in teaching and mentorship roles in computer science, including as a Senior Counselor at SummerTech at Purchase College and a remote coding tutor with Coditum and Wyzant. I taught students across skill levels using project-based learning in languages such as Java, Python, React, HTML, CSS, and JavaScript, while supporting diverse learners and mentoring junior instructors.      </p>
    </section>
  );
};

export default About;
